import React from "react";
import "./Footer.css";
import logoImg from "../assets/minds_logo.png";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container footerInner">
        <div className="footerBrandRow">
          <img className="footerLogo" src={logoImg} alt="Minds" />
          <div>
            <div className="footerBrand">Minds Educational Support</div>
            <div className="footerSub">Where Knowledge Meets Nurture</div>
          </div>
        </div>

        <div className="footerTiny">© {new Date().getFullYear()} Minds. All rights reserved.</div>
      </div>
    </footer>
  );
}